import { combineReducers } from '@reduxjs/toolkit';
import activeElementReducer from 'modules/activeElement/slice';
import devicesReducer from 'modules/devices/slice';
import linksReducer from 'modules/links/slice';
import settingsReducer from 'modules/settings/slice';
import pricesReducer from 'modules/prices/slice';

export const rootReducer = combineReducers({
  activeElement: activeElementReducer,
  devices: devicesReducer,
  links: linksReducer,
  settings: settingsReducer,
  prices: pricesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
